var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-luckey-item"},[_c('a',{staticClass:"u-pet",attrs:{"href":_vm.getPetLink(_vm.item),"target":"_blank"}},[_c('i',{staticClass:"u-img"},[_c('img',{staticClass:"u-pic",attrs:{"src":_vm.imgPath,"loading":"lazy"},on:{"error":_vm.onError}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }